import React from 'react';
import { ArrowDownRightIcon, ArrowUpRightIcon } from 'lucide-react';
interface TrendDeltaProps {
  value: number;
  /** When true, a decrease is good (e.g. missed calls) */
  invert?: boolean;
}
export function TrendDelta({
  value,
  invert = false
}: TrendDeltaProps) {
  const up = value >= 0;
  const good = invert ? !up : up;
  const Icon = up ? ArrowUpRightIcon : ArrowDownRightIcon;
  return <span className={`inline-flex items-center gap-0.5 text-xs font-semibold ${good ? 'text-positive' : 'text-danger'}`} data-id="element-155" data-mp="1vz156j07597b">
      <Icon className="h-3.5 w-3.5" aria-hidden data-id="element-156" data-mp="20w1a2qlb85wu" />
      <span className="sr-only" data-id="element-157" data-mp="25o2ig1fcxchl">{up ? 'Up' : 'Down'}</span>
      {Math.abs(value).toFixed(1)}%
    </span>;
}